import React, { useState } from 'react'

import { InfoIcon } from '../../../Icons'

export const CustomDropdown = ({ options, name, onChange, show }) => {
    const [dropdownIndex, setDropdownIndex] = useState(null);
    const [showPackagingInfo, setShowPackagingInfo] = useState(null);

    const handleSelect = (index) => {
        setDropdownIndex(index);
        if (onChange) {
            onChange({ 
                target: { 
                    name, 
                    value: options[index].val,
                    image: options[index].image
                } 
            });
        }
    };

    const handleClose = () => {
        setDropdownIndex(null);
        setShowPackagingInfo(null);
    };

    return (
        <div className='relative dropdown'>
            <div className="custom-dropdown">
                <div className="custom-dropdown-list">
                    {options.map((option, index) => (
                        <div key={index} className={`custom-dropdown-item ${index === dropdownIndex ? 'selected' : ''}`} onClick={() => handleSelect(index)}>
                            <p className='mt-0 mb-0'>{option.val}{show && <button type='button' className='btn--plain' onMouseEnter={()=>{setDropdownIndex(index); setShowPackagingInfo(true)}} onMouseLeave={()=> {setShowPackagingInfo(null)}}><InfoIcon/></button>}</p>
                        </div>
                    ))}
                </div>
            </div>
            {(showPackagingInfo && show && dropdownIndex !== null) && (
                <div className='relative description'>
                    {/* <button type='button' onClick={handleClose}><XIcon/></button> */}
                    <div className='image'>
                        <img src={options[dropdownIndex].image} alt={options[dropdownIndex].val || 'Packaging Info Media'} />
                    </div>
                    <h5 className='relative mt-0 text-center'>{options[dropdownIndex].val}</h5>
                    <p className='text-center'>{options[dropdownIndex].description}</p>
                </div>
            )}
        </div>
    );
};